import React from 'react'

export default function ButtonComponent({ type = 'button', children, className = '', color = 'orange', onClick ,disabled}) {
  return (
    <button type={type} className={`btn-container ${className} btn-${color}`} onClick={onClick} disabled={disabled}>
      <h6 className='btn-content'>
        {children}
      </h6>
    </button>
  )
}
